<template lang="pug">
#address-types.center-panel.md-scrollbar.md-theme-default
  md-content.md-elevation-1(md-theme="white")
    .md-flex(md-theme="white")
      sort-table(v-bind:columns="tableColumns" v-model="addressTypes" @refresh="getAddressTypes" link table-id="address-types" ref="table" per-page="all")
        template(slot="actions" slot-scope="scope")
          .actions-wrapper
            .actions
              span
                md-button.md-icon-button.md-dense.small(@click.stop="typeIdToDelete = scope.item.id; deleteDialog = true;"): md-icon delete
                md-tooltip(md-direction="top") Удалить
    md-button.md-dense(v-bind:to="{ name: 'AddressType', params: {type_id: 'new'} }") Добавить тип адресов #[md-icon add]
    md-dialog-confirm(:md-active.sync="deleteDialog" md-title="Удалить тип адресов?" md-content="Внимание! Действие необратимо!" md-confirm-text="Удалить" md-cancel-text="Отмена" @md-cancel="deleteDialog = false; typeIdToDelete = null;" @md-confirm="deleteAddressType")
</template>

<script>
import SortTable from '@/components/SortTable'
export default {
  components: { SortTable },
  data() {
    return {
      tableColumns: [
        { label: 'ID', field: 'id', default: true, sortable: true },
        { label: 'Название', field: 'name', sortable: true },
        { label: '', field: 'actions' },
      ],
      deleteDialog: false,
      discountIdToDelete: null
    }
  },
  metaInfo() {
    return {
      title: 'Типы адресов'
    }
  },
  computed: {
    addressTypes() {
      return this.$store.state.address.address_types.map(item => {
        item.routerLink = { name: 'AddressType', params: { type_id: item.id }, query: this.$route.query};
        return item;
      });
    }
  },
  created() {
    this.$store.commit('setTitle', 'Скидки');
  },
  methods: {
    //получение зон
    getAddressTypes(page, count, orderBy, orderType) {
      this.$store.dispatch('address/getAddressTypes', { page: page, count: count, order_by: orderBy, order_type: orderType });
    },
    deleteAddressType() {
      this.$store.dispatch('address/deleteAddressType', { id: this.typeIdToDelete }).then(() => {
        this.$nextTick(() => {
          this.$refs.table.reload();
        })
      })
      this.$store.state.address.address_types.forEach((discount, index) => {
        if (discount.id == this.typeIdToDelete) this.$store.state.address.address_types.splice(index, 1);
      })
    }
  },
}
</script>


// WEBPACK FOOTER //
// AddressTypes.vue?346863e2